import { LayoutModule } from '@angular/cdk/layout';
import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnDestroy,
  Signal,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import {
  isActive,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet
} from '@angular/router';
import { Subject } from 'rxjs';

import { EMBEDDED_APPS } from '../../../embeds/apps';
import { LanguageSwitcherComponent } from '../../../i18n/language-switcher.component';
import { TranslatePipe } from '../../../i18n/translate.pipe';
import { TranslateService } from '../../../i18n/translate.service';
import { ThemeService } from '../../../services/theme.service';
import { SidenavService } from '../sidenav.service';

@Component({
  selector: 'tehw0lf-mobile',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss'],
  imports: [
    LayoutModule,
    MatSidenavModule,
    NgClass,
    MatListModule,
    MatDivider,
    RouterLink,
    RouterLinkActive,
    MatButtonModule,
    MatIconModule,
    RouterOutlet,
    TranslatePipe,
    LanguageSwitcherComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileComponent implements AfterViewInit, OnDestroy {
  readonly apps = EMBEDDED_APPS;

  themeService = inject(ThemeService);
  translateService = inject(TranslateService);
  private router = inject(Router);
  private sidenavService = inject(SidenavService);

  @ViewChild('sidenav', { static: true }) public sidenav:
    MatSidenav | undefined;

  private unsubscribe$ = new Subject<void>();

  ngAfterViewInit(): void {
    if (this.sidenav) {
      this.sidenavService.setSidenav(this.sidenav);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private isRootActive = isActive('/', this.router, {
    paths: 'exact',
    queryParams: 'exact',
    fragment: 'ignored',
    matrixParams: 'ignored'
  });
  private isHomeActive = isActive('/home', this.router, {
    paths: 'exact',
    queryParams: 'exact',
    fragment: 'ignored',
    matrixParams: 'ignored'
  });
  isActive: Signal<boolean> = computed(
    () => this.isRootActive() || this.isHomeActive()
  );

  closeSidenav(): void {
    this.sidenavService.close();
  }

  toggleSidenav(): void {
    this.sidenavService.toggle();
  }

  switchToLight(): void {
    this.themeService.light();
  }

  switchToDark(): void {
    this.themeService.dark();
  }
}
